import TextField from "@/common/elements/InputElements/TextField";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import { getOptionsFromRefList } from "@/util/common_function";
import CommonDatePicker from "@/common/elements/DatePicker";
import { useSelector } from "react-redux";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";
import { SCHEMA_NAME } from "@/util/common_variable";

const OffenseInformation = ({ startingPoint = "" }) => {
  const { bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const fullSearch = useSelector((state) => state.fullSearch);

  return (
    <FieldSecurityProvider
      entity={SCHEMA_NAME.CHARGES}
      startingPoint={startingPoint}
      bookingsFieldsEnabled={bookingsFieldsEnabled}
    >
      <>
        <IntakeSectionHeader>
          <span>Offense Information</span>
        </IntakeSectionHeader>

        <FormContainer>
          <Row gutter={16}>
            {/* Offense Date & Time */}
            <Col span={8}>
              <SecureFormItem
                fieldName="offenseDateTime"
                formItemProps={{
                  name: "offenseDateTime",
                  label: "Offense Date & Time",
                  layout: "vertical",
                }}
              >
                <CommonDatePicker
                  placeholder="MM/DD/YYYY HH:mm"
                  format="MM/DD/YYYY HH:mm"
                  disableFutureDates={true}
                />
              </SecureFormItem>
            </Col>

            {/* Offense Location */}
            <Col span={8}>
              <SecureFormItem
                fieldName="offenseLocation"
                formItemProps={{
                  name: "offenseLocation",
                  label: "Offense Location",
                  layout: "vertical",
                }}
              >
                <TextField />
              </SecureFormItem>
            </Col>

            {/* Offense City */}
            <Col span={8}>
              <SecureFormItem
                fieldName="offenseCity"
                formItemProps={{
                  name: "offenseCity",
                  label: "Offense City",
                  layout: "vertical",
                  required: !fullSearch,
                  rules: !fullSearch
                    ? [
                        {
                          required: true,
                          message: "Offense city is required",
                        },
                      ]
                    : [],
                }}
              >
                <Select
                  options={getOptionsFromRefList("Arrest_City")}
                  placeholder="Offense City"
                  showSearch
                  variant="outlined"
                />
              </SecureFormItem>
            </Col>
          </Row>
        </FormContainer>
      </>
    </FieldSecurityProvider>
  );
};

export default OffenseInformation;